<div [ngClass]="hideSidebar ? 'hidden' : '' " class="app-sidebar-wrapper h-full hidden xl:block z-100 relative" aria-label="app-sidebar-wrapper">
  <div id="app-sidebar" class="bg-gray-900 h-screen flex-shrink-0 fixed lg:sticky left-0 top-0 border-right-1 border-gray-900" aria-label="app-sidebar">
    <div class="flex flex-column h-full w-6rem">
      <div class="flex align-items-center justify-content-center flex-shrink-0 surface-0 h-3rem p-3" aria-label="sidebar-logo-container">
        <img class="sidebar-logo" [ngClass]="sidebarMinimized ? 'w-5rem' : ''" width="130" src="assets/img/UFP-Logo.png" alt="Unified Fitness Platform Logo">
      </div>
      <div class="w-full h-full sidebar-list-wrapper text-xs flex flex-column justify-content-between" aria-label="sidebar-navigation">
        <ul class="list-none p-0 m-0 text-center app-sidebar__submenu" aria-label="main-menu">
          <li class="relative" *ngFor="let menu of Menus.asObservable() | async; let i = index " [attr.aria-label]="'menu-item-' + menu.name">
            <a  [ngClass]="selectedUrl.includes(menu.activeUrl)  ? 'bg-gray-800 border-primary' : '' " (click)="removeActiveIndex()"
              (click)="activeIndex=i" pRipple
              [routerLink]="menu.url?menu.url:null"
              class="no-underline cursor-pointer py-3 pr-2 pl-1 block text-white transition-duration-150 transition-all hover:bg-gray-800 hover:border-primary border-left-3 border-transparent" pStyleClass="@next" enterFromClass="hidden" leaveToClass="hidden" [hideOnOutsideClick]="true" [attr.aria-label]="'menu-link-' + menu.name">
              <i class="fa {{menu.icon}} text-lg" [attr.aria-label]="'menu-icon-' + menu.name"></i>
              <span class="font-medium mt-1 block">{{ 'common.SIDEBAR.' + menu.title | translate }}</span>
            </a>  
            <div *ngIf="menu?.submenus && menu?.submenus?.length>0" class="hidden absolute top-0 left-100 text-sm text-left md:text-xs py-2 bg-gray-800 w-10rem border-round text-white transition-all transition-duration-400 transition-ease-in-out" [attr.aria-label]="'submenu-' + menu.title">
              <ul class="list-none p-0 m-0" aria-label="submenu-list">
                <li *ngFor="let submenu of menu.submenus" [ngClass]="{'pointer-events-none opacity-40' : submenu.disabled}" pStyleClass="@grandparent" enterFromClass="hidden" leaveToClass="hidden" [attr.aria-label]="'submenu-item-' + submenu.name">
                  <a pRipple [routerLink]="submenu.url"
                    class="flex align-items-center cursor-pointer hover:bg-blue-800 text-500 hover:text-blue-200 transition-duration-150 transition-colors p-2" [attr.aria-label]="'submenu-link-' + submenu.name">
                    <span class="font-medium ml-2">{{'common.SIDEBAR.' + submenu.title | translate }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="list-none px-0 py-2 m-0 text-center border-top-1 border-gray-700" aria-label="footer-menu">
          <li *ngIf="!showEnterpriseMaster.value" aria-label="admin-menu-item">
            <a pRipple [routerLink]="AdminMenu.url"
              class="no-underline cursor-pointer px-3 py-2 block border-round transition-duration-150 transition-all text-300 hover:bg-gray-800 hover:border-primary border-left-3 border-transparent" aria-label="admin-link">
              <i class="fa fa-cog text-lg" aria-label="admin-icon"></i>
            </a>
          </li>
          <li *ngIf="showEnterpriseMaster.value" class="relative" aria-label="enterprise-menu-item">
            <a pRipple
              class="no-underline cursor-pointer px-3 py-2 block border-round transition-duration-150 transition-all text-300 hover:bg-gray-800 hover:border-primary border-left-3 border-transparent"
              pStyleClass="@next" enterFromClass="hidden" leaveToClass="hidden" [hideOnOutsideClick]="true" aria-label="enterprise-link">
              <i class="fa fa-cog text-lg" aria-label="enterprise-icon"></i>
            </a>
            <div
              [ngClass]="(langDirection | async)=='ltr'?'left-100':'right-100'"
               class="absolute hidden top-0 left-100 text-sm text-left md:text-xs bg-gray-800 w-10rem border-round text-white transition-all transition-duration-400 transition-ease-in-out" aria-label="enterprise-submenu">
             <div class="p-2">
                <div class="border-gray-600 py-1" [routerLink]="AdminMenu.url" pStyleClass="@grandparent" leaveToClass="hidden" aria-label="admin-option">
                  <div data-featurebase-feedback class="cursor-pointer px-2 py-1" aria-label="admin-link">Admin</div>
                </div>
                <div class="border-gray-600 py-1" [routerLink]="'/enterprise'" pStyleClass="@grandparent"  leaveToClass="hidden" aria-label="enterprise-option">
                  <div class="cursor-pointer px-2 py-1" aria-label="enterprise-link">Enterprise</div>
                </div>
              </div>
            </div>
          </li>
          <li class="md:hidden" aria-label="notification-menu-item">
              <a pRipple
                 class="no-underline cursor-pointer px-3 py-2 block border-round transition-duration-150 transition-all text-300 hover:bg-gray-800 hover:border-primary border-left-3 border-transparent relative" aria-label="notification-link">
              <i class="fa fa-bullhorn text-lg mr-2 lg:mr-0" aria-label="notification-icon"></i>
              <i class="fa fa-circle text-xs text-red absolute right-0 top-0 mr-5" aria-label="notification-indicator"></i>
            </a>
          </li>
          <li class="relative" *ngIf="userDetails$ | async  as usr" aria-label="user-profile-menu-item">
            <a pRipple
            class="no-underline cursor-pointer px-3 py-2 block border-round transition-duration-150 transition-all text-300 hover:bg-gray-800 hover:border-primary border-left-3 border-transparent"
            pStyleClass="@next" enterFromClass="hidden" leaveToClass="hidden" [hideOnOutsideClick]="true" aria-label="user-profile-link">
            <ng-container *ngIf="usr && usr.ff_picture;else noImage">
              <p-avatar [image]="usr.ff_picture" shape="" [attr.aria-label]="'user-avatar-' + usr.name"></p-avatar>
            </ng-container>
            <ng-template #noImage>
              <p-avatar [label]="client2LetterName(usr.name) | titlecase | shortName" shape="" styleClass="text-gray-900" [attr.aria-label]="'user-avatar-' + usr.name"></p-avatar>
            </ng-template>
          </a>
          <div [ngClass]="(langDirection |async)=='ltr'?'left-100':'right-100'" 
            class="absolute bottom-0 left-100 bg-gray-700 text-white border-round shadow-2 hidden w-15rem text-left text-sm p-1" aria-label="user-profile-menu">

          <div class="p-2">
            <div class="flex align-items-center mb-2">
              <ng-container *ngIf="usr && usr.ff_picture;else noImage">
                <p-avatar [image]="usr.ff_picture" shape="" [attr.aria-label]="'user-avatar-' + usr.name"></p-avatar>
              </ng-container>
              <ng-template #noImage>
                <p-avatar [label]="client2LetterName(usr.name) | titlecase | shortName" shape="" styleClass="text-gray-900" [attr.aria-label]="'user-avatar-' + usr.name"></p-avatar>
              </ng-template>
              <div class="flex align-items-start justify-content-between ml-2 w-full">
              <div>
              <div class="font-bold w-8rem overflow-hidden text-overflow-ellipsis white-space-nowrap"*ngIf="usr.name" aria-label="user-name">{{usr.name}}</div>
              <a  class="text-gray-500 text-xs" *ngIf="usr.mobile_country_code;else phone; " [href]="'tel:'+usr.mobile_country_code +usr.mobile_number" aria-label="user-phone">{{usr.mobile_country_code}}{{usr.mobile_number}}</a>
              <ng-template #phone><span aria-label="phone-not-specified">{{'HEADER.NOT_SPECIFIED' | translate}}</span></ng-template>
            </div>
            <div class="bg-blue-50 border-primary border-1 px-2 py-1 font-bold border-round text-primary text-xxs"*ngIf="usr.role" aria-label="user-role">{{usr.role}}</div>
            </div>
            </div>
            <div (click)="showSidebar = true" class="mt-2 bg-gray-900 text-primary font-bold text-center border-round p-2 cursor-pointer" data-testid="preferences-button">{{'HEADER.PREFERENCES' | translate}}</div>
          </div>
          <div class="border-top-1 border-gray-600 py-1">
            <div data-featurebase-feedback class="cursor-pointer px-2 py-1" (click)="openFeedback()" data-testid="feedback-button">Feedback</div>
          </div>
          <div class="border-top-1 border-gray-600 py-1">
            <div  [routerLink]="'/auth/logout'" class="cursor-pointer px-2 py-1" data-testid="logout-button">{{'HEADER.LOGOUT' | translate}}</div>
          </div>
        </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<staff-preferences *ngIf="showSidebar"
  [showClientSidebar]="showSidebar"
  [activeStaffId]="selectedStaffId"
  (closeSidebar)="handleCloseSidebar($event)"
  aria-label="staff-preferences-sidebar">
</staff-preferences>
